/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-wrapper[_ngcontent-%COMP%]{background-image:url(/images/gamification/bg-gamification.jpg);background-repeat:no-repeat;background-position:0 0;background-size:cover;border-bottom:1px solid #b3d7ff}.progress-wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#000}.small-level-title[_ngcontent-%COMP%]{font-family:PoppinsRegular,Arial,Helvetica,sans-serif;font-size:1.25rem;font-weight:700;color:#444}@media (min-width:711px){.small-level-title[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
//# sourceMappingURL=progress-page-progress-section.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/progress-page-progress-section/progress-page-progress-section.component.scss.shim.ngstyle.js
// module id = 1588
// module chunks = 26 27 28